import React, { useEffect, useState } from 'react'

import { Select } from 'src/components/Formik'
import OrganizationsService, {
  GetOrganizationByCurrentManagerData
} from 'src/services/api/organizations'

import { SelectProps, Option } from '../Select'
import { SelectFake } from '../select-fake'

interface Props extends Omit<SelectProps, 'name' | 'options'> {
  name?: string
}

function manageOrganizationData(
  data: GetOrganizationByCurrentManagerData
): Option[] {
  if (!data?.organizations_current_manager) {
    return []
  }

  return data.organizations_current_manager.map(d => ({
    label: `${d.legal_name}`,
    title: `${d.legal_name}`,
    value: `${d.organization_id}`
  }))
}

export default function SelectOrganizationCurrentManager({
  formikProps,
  required,
  ...props
}: Props) {
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [hasError, setHasError] = useState<boolean>(false)
  const [options, setOptions] = useState<Option[]>([])

  useEffect(() => {
    setIsLoading(true)
    setHasError(false)
    OrganizationsService.getOrganizationByCurrentManager()
      .then(values => {
        if (values?.status === 200) {
          const defaultOptions = manageOrganizationData(values?.data)
          formikProps.setFieldValue(
            'organization_id',
            defaultOptions?.[0]?.value || ''
          )
          setOptions(defaultOptions)
        } else {
          setHasError(true)
        }
      })
      .catch(() => {
        setHasError(true)
      })
      .finally(() => {
        setIsLoading(false)
      })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const label = 'web.integration.table.column.organization'
  const name = 'organization_id'

  if (hasError) {
    const fakeOptions = {
      label: `Loading error`
    }

    return (
      <SelectFake
        fakeOptions={fakeOptions}
        formikProps={formikProps}
        label={label}
        name={name}
        required={required}
      />
    )
  }

  if (isLoading) {
    const fakeOptions = {
      label: ''
    }

    return (
      <SelectFake
        fakeOptions={fakeOptions}
        label={label}
        loading
        required={required}
      />
    )
  }

  return (
    <Select
      {...props}
      dataTestId="currentManager-list"
      formikProps={formikProps}
      label={label}
      name={name}
      options={options}
      required={required}
    />
  )
}
